<template>
    <div class="main-container">
        <div class="main-container-title-box">
            <div class="main-container-title-box-text">
                <span class="title-box-text">
                    Push-уведомления Quorum
                </span>

            </div>
            <v-spacer></v-spacer>

            <v-text-field @input="getPush(true)" append-icon="mdi-magnify" class="search-input" hide-details label="Поиск"
                color="var(--app-dark-blue-1)" single-line v-model="search"></v-text-field>
        </div>


        <div>

            <div class="table-container">
                <v-data-table :headers="tableHeaders" :items="pushItems"
                    :footer-props="{ itemsPerPageOptions: [10, 25, 50], 'items-per-page-text': '' }"
                    class="elevation-0 main-table" :items-per-page="optionTable.itemsPerPage" :page="optionTable.page"
                    :server-items-length="optionTable.serverItemsLength" @pagination="tableChange" ref="sortableTable">
                    <template v-slot:item.sentCount="{ item }">
                        <template v-if="item.items">
                            {{ item.items.sentCount }}
                        </template>
                    </template>
                    <template v-slot:item.notSentCount="{ item }">
                        <template v-if="item.items">
                            {{ item.items.notSentCount }}
                        </template>
                    </template>
                    <template v-slot:item.totalCount="{ item }">
                        <template v-if="item.items">
                            {{ item.items.totalCount }}
                        </template>
                    </template>
                    <template v-slot:item.percentSent="{ item }">
                        <template v-if="item.items">
                            {{ Math.floor((item.items.sentCount / item.items.totalCount) * 100) }}
                        </template>
                    </template>
                    <template v-slot:item.isSent="{ item }">
                        <span v-if="item.isSend"> Да</span>
                        <span v-else>Нет</span>
                    </template>
                    <template v-slot:item.dateCreated="{ item }">
                        {{ item.dateCreated | moment(" HH:mm DD.MM.YYYY ") }}
                    </template>
                    <template v-slot:item.actions="{ item }">
                        <v-icon @click="deletePush(item.id)" color="var(--app-red-1)">mdi-delete-outline</v-icon>
                    </template>

                </v-data-table>

            </div>
        </div>
        <v-divider></v-divider>
    </div>
</template>
<script>


export default {

    data: () => ({
        showInfo: false,
        x: null,
        y: null,
        pushItems: [],
        search: '',
        optionTable: {
            page: 1,
            itemsPerPage: 10,
            serverItemsLength: -1
        },

        tableHeaders: [
            {
                text: 'ID',
                sortable: false,
                value: 'id'
            },
            {
                text: 'Заголовок',
                sortable: false,
                value: 'title'
            },
            {
                text: 'Описание',
                sortable: false,
                value: 'description'
            },

            {
                text: 'Кол-во отправленных',
                sortable: false,
                value: 'sentCount'
            },
            {
                text: 'Кол-во не отправленных',
                sortable: false,
                value: 'notSentCount'

            },
            {
                text: 'Общее кол-во',
                sortable: false,
                value: 'totalCount'
            },
            {
                text: 'Процент отправленных',
                sortable: false,
                value: 'percentSent'
            },

            {
                text: 'Отправленно',
                sortable: false,
                value: 'isSent'

            },
            {
                text: 'Дата создания',
                sortable: false,
                value: 'dateCreated'
            },
            {
                text: '',
                sortable: false,
                value: 'actions'

            },

        ],
    }),
    methods: {
        checkLocal() {
            const localOptionTable = JSON.parse(localStorage.getItem("pushOptionTable"))
            if (localOptionTable) {
                this.optionTable = localOptionTable
            }

        },

        goToCreate() {
            this.$router.push({ name: 'CreateCategories' })

        },
        deletePush(id) {
            this.$axios.delete(this.$store.getters.apiAdminPanelV2 + '/quorum/push', {
                headers: {
                    'authorization': this.$store.getters.adminPanelHeaderAuth
                },
                params: {
                    pushId: id
                }
            })
                .then(() => {
                    this.getPush()
                })
                .catch(err => {
                    this.$store.commit('errorSet', true)
                    this.$store.commit('errorTextSet', err)
                })
        },
        getPush(search) {
            if (search) {
                this.optionTable.page = 1
            }
            this.$axios.post(this.$store.getters.apiAdminPanelV2 + '/quorum/push/list', {
                optionTable: this.optionTable,
                search: this.search

            }, {
                headers: {
                    'authorization': this.$store.getters.adminPanelHeaderAuth
                }
            })
                .then(res => {

                    this.optionTable = res.data.optionTable;
                    this.pushItems = res.data.items

                })
                .catch(err => {
                    this.$store.commit('errorSet', true)
                    this.$store.commit('errorTextSet', err)
                })

        },
        tableChange(data) {

            this.optionTable.page = data.page
            this.optionTable.itemsPerPage = data.itemsPerPage
            localStorage.setItem('pushOptionTable', JSON.stringify(this.optionTable))
            this.getPush()
        },


    },
    created() {
        this.checkLocal()
        this.getPush()
    },
}
</script>
<style lang="scss" scoped>
.table-container {
    height: calc(100vh - 195px);

    .main-table {
        height: calc(100vh - 195px) !important;
        min-height: calc(100vh - 195px) !important;
        max-height: calc(100vh - 195px) !important;
        display: flex;
        flex-direction: column;
        justify-content: space-between;

    }
}
</style>